module.exports = " <div class=ui> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <paco-agreement> <h1 class=title>平安产险服务窗平台协议</h1> <p class=welcome>欢迎您使用服务窗平台！</p> <p class=foreword>为使用平安产险服务窗平台服务（以下简称『本服务』），你应该阅读并遵守《平安产险服务窗平台协议》(以下简称『本协议』)。</p> <h2 class=sub-title>一、【协议的范围】</h2> <p>1.1 本协议是你与平安产险之间...</p> <h2 class=sub-title>二、【定义和理解】</h2> <p>2.1 本协议是你与平安产险之间...</p> <p>2.2 更多协议...</p> </paco-agreement> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/AgreementView.vue
// module id = 143
// module chunks = 1